import { Directive, HostListener } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';


@Directive({
  standalone: true,
  selector: '[enterTogglesCheckbox]',
})
export class EnterTogglesCheckboxDirective {
  constructor(private checkbox: MatCheckbox) {
  }

  @HostListener('keydown.enter', ['$event'])
  onEnter(event: KeyboardEvent) {
    if (this.checkbox.disabled) {
      return;
    }
    event.preventDefault();
    this.checkbox.toggle();
  }
}
